import { useState, useEffect } from "react";
import { getAllTags } from "../services/blogService";

export default function TagFilter({ activeTags, onTagToggle }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllTags()
      .then(setTags)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading || tags.length === 0) return null;

  return (
    <div className="mb-6">
      <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">
        Filter by Tags
      </h3>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <button
            key={tag.name}
            onClick={() => onTagToggle(tag.name)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all ${
              activeTags.includes(tag.name)
                ? "bg-tech-green/20 text-tech-green border border-tech-green/30"
                : "glass text-gray-400 hover:text-white hover:bg-white/10"
            }`}
          >
            {tag.name}
            <span className="ml-1 text-gray-600">({tag.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
}
